<figure class="image is-200x200">
  <img [src]="imagePath">
</figure>
